module.exports = "static/assets/651d8e5ba636c4fdca2a884b4e700f99.png";